// Les PDF utilisent la police Roboto, qui n'a pas de glyphes arabes : ce texte serait enregistré
// mais absent de l'impression. Le message est affiché sous le champ concerné (directive AvertArabeDirective).
const ARABIC = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;

export function contientArabe(valeur: any): boolean {
	if (Array.isArray(valeur)) {
		return valeur.some(contientArabe);
	}
	return typeof valeur === 'string' && ARABIC.test(valeur);
}
